class ScrollProviderClass {

  private scrollInProcess = false;

  async scrollX(el: any, x: number, smooth: boolean = true) {
    if(smooth) {
      if(!this.scrollInProcess) {
        this.scrollInProcess = true;
        let current = el.scrollLeft;
        let multi = (el.offsetWidth / 100);
        let calcFactor = (a, b) => a - b > 0 ? (a - b) : (b - a);
        let getFactor = (value) => value / el.offsetWidth;
        let space = Math.round(getFactor(calcFactor(x, current)) * multi);
        space = space > 0 ? space : space = 10;
        let direction = () => current < x;
        let calculate = () => {
          if((current + space) > x) {
            current = x;
            return; 
          }
          current += space;
        };
        if(x < current) {
          calculate = () => {
            if((current - space) < 0) {
              current = 0;
              return; 
            }
            current -= space;
          };
          direction = () => current > x;
        }
        while(direction()) {
          calculate();
          await this.scrollSmoothX(el, current);
        }
        this.scrollInProcess = false;
      }
    } else {
      el.scrollTo({ left: x });
    }
  }

  private async scrollSmoothX(el, to): Promise<any> {
    await new Promise(resolve => {
      setTimeout(() => {
        el.scrollTo({ left: to });
        resolve(to);
      }, 0)
    });
  }
  
}

export const ScrollProvider = new ScrollProviderClass();

